document.querySelectorAll('.quantity-input').forEach(function (wrapper) {
  const minusBtn = wrapper.querySelector('button[name="minus"]');
  const plusBtn = wrapper.querySelector('button[name="plus"]');
  const input = wrapper.querySelector('input[type="number"]');

  if (!input) return;

  const min = parseInt(input.getAttribute('min')) || 1;
  const max = parseInt(input.getAttribute('max')) || 999;

  plusBtn?.addEventListener('click', function () {
    let current = parseInt(input.value) || min;
    if (current < max) {
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  minusBtn?.addEventListener('click', function () {
    let current = parseInt(input.value) || min;
    if (current > min) {
      input.value = current - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

// ------------------------------
// custom-variant-selects class
// ------------------------------

if (!customElements.get('custom-variant-selects')) {
  class CustomVariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formId = '';
    }

    connectedCallback() {
      this.formId = `#product-form-${this.dataset.section}`;
      this.variantData = this.getVariantData();
      this.attachEventListeners();
    }

    getVariantData() {
      const scriptTag = document.querySelector('script[data-selected-variant]');
      return scriptTag ? JSON.parse(scriptTag.textContent) : [];
    }

    attachEventListeners() {
      const radios = this.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        radio.addEventListener('change', () => this.onVariantChange());
      });
    }

    getSelectedOptions() {
      const selected = {};
      const checkedRadios = this.querySelectorAll('input[type="radio"]:checked');
      checkedRadios.forEach(radio => {
        const name = radio.name.split('-')[0];
        selected[name] = radio.value;
      });
      return selected;
    }

    findMatchingVariant(selectedOptions) {
      return this.variantData.find(variant => {
        const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        const keys = Object.keys(selectedOptions);
        return keys.every((key, i) => selectedOptions[key] === options[i]);
      });
    }

    updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    updateFormVariantInput(variantId) {
      const form = document.querySelector(this.formId);
      if (!form) return;
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = variantId;
    }

    updateVisibleSectionsForVariant(variantId) {
      const variantSections = document.querySelectorAll('[data-variant-id]');

      variantSections.forEach(section => {
        const isMatch = section.getAttribute('data-variant-id') == variantId;
        section.removeAttribute('data-color-initialized');

        if (isMatch) {
          section.classList.add('section_show');
          section.classList.remove('section_hide');

          const selectedColorWrapper = document.querySelector('[data-selected-color]');
          if (selectedColorWrapper) {
            const selectedColorValue = selectedColorWrapper.getAttribute('data-selected-color');
            const colorRadios = section.querySelectorAll('input[type="radio"][data-color]');
            let matchFound = false;

            colorRadios.forEach(radio => {
              if (radio.getAttribute('data-color') === selectedColorValue) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
                matchFound = true;
              } else {
                radio.checked = false;
              }
            });

            if (!matchFound && colorRadios.length > 0) {
              const firstRadio = colorRadios[0];
              firstRadio.checked = true;
              firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          initVariantColorSelectors();
        } else {
          section.classList.remove('section_show');
          section.classList.add('section_hide');
        }
      });
    }

    async fetchUpdatedVariantHTML() {
      const url = new URL(window.location.href);
      const pathname = url.pathname;
      const cleanUrl = pathname + url.search;

      try {
        const response = await fetch(cleanUrl, {
          headers: {
            'Content-Type': 'text/html',
            'Accept': 'text/html'
          }
        });

        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newVariantEl = doc.querySelector(`custom-variant-selects[data-section="${this.dataset.section}"]`);
        const currentForm = document.querySelector(this.formId);

        const newWidget = doc.querySelector('#sce-widget');
        const currentWidget = document.querySelector('#sce-widget');

        if (newWidget && currentWidget) {
            currentWidget.replaceWith(newWidget.cloneNode(true));
        }

        if (newVariantEl && currentForm) {
          const newAddButton = newVariantEl.querySelector('form [name="add"]');
          const currentAddButton = currentForm.querySelector('[name="add"]');

          if (newAddButton && currentAddButton) {
            currentAddButton.replaceWith(newAddButton.cloneNode(true));
          }

          this.innerHTML = newVariantEl.innerHTML;
          this.variantData = this.getVariantData();
          this.attachEventListeners();
        }
      } catch (error) {
        console.error('Failed to fetch updated variant HTML:', error);
      }
    }

    async onVariantChange() {
      const selectedOptions = this.getSelectedOptions();
      let matchedVariant = this.findMatchingVariant(selectedOptions);

      if (!matchedVariant && this.variantData.length > 0) {
        const selectedKeys = Object.keys(selectedOptions);
        const primaryKey = selectedKeys[0];
        const primaryValue = selectedOptions[primaryKey];

        matchedVariant = this.variantData.find(variant => {
          const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
          return options[0] === primaryValue;
        }) || this.variantData[0];
      }

      if (matchedVariant) {
        this.updateUrl(matchedVariant.id);
        this.updateFormVariantInput(matchedVariant.id);
        this.updateVisibleSectionsForVariant(matchedVariant.id);
        // updateMediaGalleryFromVariant();
        await this.fetchUpdatedVariantHTML();
        openSizeChartModal();
      }
    }
  }
  customElements.define('custom-variant-selects', CustomVariantSelects);
}

// ------------------------------
// VariantColorSelector class
// ------------------------------

class VariantColorSelector {
  constructor(wrapper) {
    this.wrapper = wrapper;
    if (!this.wrapper.classList.contains('section_show')) return;
    if (this.wrapper.dataset.colorInitialized === 'true') return;
    this.wrapper.dataset.colorInitialized = 'true';

    this.colorContainer = wrapper.querySelector('.custom-variant-picker__input.custom-variant-picker__color');
    this.selectedColorEl = document.querySelector('[data-selected-color]');
    this.colorRadios = this.colorContainer?.querySelectorAll('input[type="radio"][data-color]');
    this.selectedValueSpan = this.colorContainer?.querySelector('[data-selected-value]');
    this.selectedColorCode = this.selectedColorEl?.getAttribute('data-selected-color')?.toLowerCase();

    this.init();
  }

  init() {
    if (!this.colorRadios || !this.selectedColorCode) return;
    this.setInitialColor();
    this.addEventListeners();
  }

  setInitialColor() {
    this.colorRadios.forEach(radio => {
      const color = radio.getAttribute('data-color')?.toLowerCase();
      if (color === this.selectedColorCode) {
        radio.checked = true;
        this.updateSelectedValueText(radio);
        this.updateMediaSlideBackground(radio.dataset.color);
      }
    });
  }

  addEventListeners() {
    this.colorRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          const colorCode = radio.dataset.color;
          this.selectedColorEl?.setAttribute('data-selected-color', colorCode);
          const widget = document.querySelector('#sce-widget');
          widget.setAttribute('data-tshirtcolor', colorCode);
          this.updateSelectedValueText(radio);
          this.updateMediaSlideBackground(colorCode);
        }
      });
    });
  }
  
  updateSelectedValueText(radio) {
    const labelHidden = this.wrapper.querySelector(`label[for="${radio.id}"] .custom-variant-picker__option-label-hidden`);
    if (labelHidden && this.selectedValueSpan) {
      this.selectedValueSpan.innerText = labelHidden.innerText;
    }
  }
  
  updateMediaSlideBackground(colorCode) {
    const mediaContainer = document.getElementById('media-grid-container');
    if (!mediaContainer || !colorCode) return;
    
    const properties_color = document.querySelector('#properties_color');
    properties_color.value = colorCode;
    
    mediaContainer.querySelectorAll('.swiper-slide img').forEach(image => {
      image.style.backgroundColor = colorCode;
    });
  }
}

// ------------------------------
// Media Gallery
// ------------------------------

// function updateMediaGalleryFromVariant() {
//   const mediaJsonEl = document.getElementById('media-json');
//   const mediaData = JSON.parse(mediaJsonEl?.textContent || '{}');
//   const container = document.getElementById('media-grid-container');
//   if (!container || !mediaData.items || !mediaData.items.length) return;

//   // Additional images from data attribute
//   const additionalImages = mediaJsonEl.dataset.additionalImages 
//     ? JSON.parse(mediaJsonEl.dataset.additionalImages) 
//     : [];

//   const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
//   const selectedOptions = Array.from(checkedRadios).map(r => r.value?.trim().toLowerCase());

//   const matchedItem = mediaData.items.find(item =>
//     selectedOptions.includes(item.BodystyleName?.trim().toLowerCase())
//   ) || mediaData.items[0];

//   container.innerHTML = '';

//   const swiperMainId = `swiper-main-${Date.now()}`;
//   const swiperThumbsId = `swiper-thumbs-${Date.now()}`;

//   // Merge body_styles images + additional images
//   const allImages = [
//     ...matchedItem.Images,
//     ...additionalImages.map(url => ({ imageUrl: url, location: 'additional' }))
//   ];

//   const wrapper = document.createElement('div');
//   wrapper.className = 'media-grid-wrapper';
//   wrapper.innerHTML = `
//     <div class="swiper ${swiperMainId}">
//       <div class="swiper-wrapper">
//         ${allImages.map(img => `
//           <div class="swiper-slide"><img src="${img.imageUrl}" alt="${img.location}" /></div>
//         `).join('')}
//       </div>
//     </div>
//     <div class="swiper ${swiperThumbsId}">
//       <div class="swiper-wrapper">
//         ${allImages.map(img => `
//           <div class="swiper-slide"><img src="${img.imageUrl}" alt="${img.location}" /></div>
//         `).join('')}
//       </div>
//     </div>
//   `;
//   container.appendChild(wrapper);

//   const thumbsSwiper = new Swiper(`.${swiperThumbsId}`, {
//     slidesPerView: 4,
//     spaceBetween: 10,
//     watchSlidesProgress: true,
//     breakpoints: { 640: { slidesPerView: 5 }, 1024: { slidesPerView: 6 } }
//   });

//   new Swiper(`.${swiperMainId}`, {
//     spaceBetween: 10,
//     navigation: true,
//     thumbs: { swiper: thumbsSwiper }
//   });

//   const properties_image = document.querySelector('#properties_image');
//   if (properties_image) properties_image.value = allImages[0].imageUrl;

//   const selectedColor = document.querySelector('[data-selected-color]')?.getAttribute('data-selected-color');
//   if (selectedColor) {
//     container.querySelectorAll('.swiper-slide img').forEach(img => {
//       img.style.backgroundColor = selectedColor;
//     });
//   }
// }

function updateMediaGalleryFromVariant() {
  const mediaJsonEl = document.getElementById('media-json');
  const container = document.getElementById('media-grid-container');
  if (!container) return;

  // Additional images from data attribute
  const additionalImages = mediaJsonEl.dataset.additionalImages 
    ? JSON.parse(mediaJsonEl.dataset.additionalImages) 
    : [];

  container.innerHTML = '';

  const swiperMainId = `swiper-main-${Date.now()}`;
  const swiperThumbsId = `swiper-thumbs-${Date.now()}`;

  // Only additional images
  const allImages = additionalImages.map(url => ({
    imageUrl: url,
    location: 'additional'
  }));

  const wrapper = document.createElement('div');
  wrapper.className = 'media-grid-wrapper';
  wrapper.innerHTML = `
    <div class="swiper ${swiperMainId}">
      <div class="swiper-wrapper">
        ${allImages.map(img => `
          <div class="swiper-slide"><img src="${img.imageUrl}" alt="${img.location}" /></div>
        `).join('')}
      </div>

      <!-- Navigation Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>

      <!-- Pagination Dots -->
      <div class="swiper-pagination"></div>
    </div>

    <div class="swiper ${swiperThumbsId}">
      <div class="swiper-wrapper">
        ${allImages.map(img => `
          <div class="swiper-slide"><img src="${img.imageUrl}" alt="${img.location}" /></div>
        `).join('')}
      </div>
    </div>
  `;
  container.appendChild(wrapper);

  const thumbsSwiper = new Swiper(`.${swiperThumbsId}`, {
    slidesPerView: 4,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: { 640: { slidesPerView: 5 }, 1024: { slidesPerView: 6 } }
  });

  new Swiper(`.${swiperMainId}`, {
    spaceBetween: 10,
    navigation: {
      nextEl: `.${swiperMainId} .swiper-button-next`,
      prevEl: `.${swiperMainId} .swiper-button-prev`,
    },
    pagination: {
      el: `.${swiperMainId} .swiper-pagination`,
      clickable: true,
    },
    thumbs: { swiper: thumbsSwiper }
  });

}


// ------------------------------
// size chart button
// ------------------------------

function openSizeChartModal(triggerSelector = '.open-size-chart button') {
  const sizeButtons = document.querySelectorAll(triggerSelector);

  sizeButtons.forEach(button => {
    button.addEventListener('click', event => {
      const modalId = event.currentTarget.getAttribute('data-modal');
      if (!modalId) return;

      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');

        const closeBtn = modal.querySelector('.f-modal__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            modal.classList.add('hidden');
            modal.setAttribute('aria-hidden', 'true');
          });
        }
      }
    });
  });
}


// ------------------------------
// Init Helpers
// ------------------------------

document.addEventListener('DOMContentLoaded', () => {
  openSizeChartModal();
  initVariantColorSelectors();
  // updateMediaGalleryFromVariant();
});

window.addEventListener('load', () => {
  openSizeChartModal();
  initVariantColorSelectors();
  // updateMediaGalleryFromVariant();
});

function initVariantColorSelectors() {
  document.querySelectorAll('.custom-variant-picker__field-wrapper.section_show').forEach(wrapper => {
    new VariantColorSelector(wrapper);
  });
}

const observer = new MutationObserver(() => {
  initVariantColorSelectors();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});



addEventListener("DOMContentLoaded", (event) => {
  var hidden_link = document.querySelectorAll('.wc_remove_css_file');
  document.querySelectorAll('.customize_click').forEach(function(self){
    self.addEventListener('click', function() {      
      document.querySelector('.customise-popup').style.display = 'block';
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('show-product--customizer');
      document.querySelector('html').style.fontSize = '100%';
      var my_awesome_script = document.createElement('script');
      my_awesome_script.setAttribute('src','https://app.tzilla.com/widget/index.js');
      my_awesome_script.setAttribute('class','tzilla_widget_script');
      hidden_link.forEach(function(self){
        var current_href = self.getAttribute('href');
        self.setAttribute('data-href', current_href);
        self.setAttribute('href', '');
      });
      document.head.appendChild(my_awesome_script);
    });
  })
});
window.th_addToCart = async function th_addToCart(details) {
  try {
    console.log('details', details);
    // ----- 0) Safety -----
    if (!details) throw new Error('Missing details');
    const widget = document.querySelector('#sce-widget');
    if (!widget) throw new Error('Missing #sce-widget');
    const handle = widget.dataset.handle || widget.getAttribute('data-handle') || details.productHandle;
    if (!handle) throw new Error('Missing product handle on #sce-widget');

    // ----- 1) Fetch product JSON once -----
    const product = await fetch(`/products/${encodeURIComponent(handle)}.js`).then(r => {
      if (!r.ok) throw new Error('Failed to fetch product JSON');
      return r.json();
    });

    // ----- 2) Resolve body style (number -> name) & size -----
    const size = String(details.body_size || '').trim(); // e.g. "M"
    const styleNum = Number(details.body_style);         // e.g. 5

    const styleOpt =
      product.options.find(o => (o.name || '').toLowerCase() === 'style') ||
      product.options[0];

    if (!styleOpt || !Array.isArray(styleOpt.values)) {
      throw new Error('Product has no style option values');
    }

    // Assuming 1-based index from your UI for body_style
    const styleNameInput = document.querySelector('input[name="style-1"][data-value-number="'+ styleNum +'"]');
    let styleName;
    if(!styleNameInput){
      styleName = details.body_size;
    }else{
      styleName = styleNameInput.value;
    }
    if (!styleName) throw new Error(`Cannot map body_style=${styleNum} to a style value`);

    // Find variant (style = option1, size = option2 in your JSON)
    const variant =
      product.variants.find(v => v.option1 === styleName && v.option2 === size) ||
      product.variants.find(v => Array.isArray(v.options) && v.options.includes(styleName) && v.options.includes(size));

    if (!variant) throw new Error(`No variant for "${styleName}" + "${size}"`);

    const variantID = variant.id;

    const properties = {};
    const image_id          = details.image_id;
    const image_url         = details.image_url;
    const tshirt_color      = details.tshirt_color;
    const tshirt_color_name = details.tshirt_color_name;

    // const is_CustomPnlAdded = details.isCustomPnlAdded
    // if (is_CustomPnlAdded) properties['_extra_customise_prd'] = is_CustomPnlAdded

    if (image_id)           properties['_image_id']     = image_id;
    if (image_url)          properties['_image_url']    = image_url;
    if (tshirt_color)       properties['_tshirt_color'] = tshirt_color;
    if (tshirt_color_name)  properties['Color']         = tshirt_color_name;

    const SIDE_FALLBACK = ['Front', 'Back', 'Left', 'Right'];
    if (Array.isArray(details.items)) {
      const imagesCompact = [];

      details.items.forEach((it, idx) => {
        if (!it) return;

        const imgId  = it.image_id  ?? it.id  ?? null;
        const imgUrl = it.image_url ?? it.url ?? null;

        // Prefer provided side/title/name; otherwise use index fallback
        const labelRaw = it.side || it.title || it.name || SIDE_FALLBACK[idx] || `Image ${idx + 1}`;
        const label    = String(labelRaw).trim();

        if (imgUrl) properties[`_${label}_url`] = imgUrl;
        if (imgId)  properties[`_${label}_id`]  = imgId;

        if (imgUrl || imgId) {
          imagesCompact.push({ label, image_id: imgId || undefined, image_url: imgUrl || undefined });
        }
      });

      if (imagesCompact.length) {
        properties['_design_images'] = JSON.stringify(imagesCompact);
      }
    }
    const formData = {
      id: variantID,
      quantity: 1,
      properties
    };

    // await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(formData)
    // });

     const mainRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    if (!mainRes.ok) throw new Error('Failed to add main product to cart');
    const mainData = await mainRes.json();
    console.log('Main product added:', mainData);

    // Add extra cost product (AFTER success)
    if (details.isCustomPnlAdded) {
      const mainKey = mainData.key;
      await extraProductAdd(51919178072369, mainKey);
    } else {
      window.location.href = '/cart';
    }
    

    // window.location.href = '/cart';
    // Redirect to product page & flag to open drawer
    sessionStorage.setItem('openCartDrawerAfterLoad', 'true');
    // window.location.href = `/products/${handle}`;
  } catch (err) {
    alert('Sorry for the inconvenience. Try adding again in a while…');
    console.error('[th_addToCart] Error:', err);
  }
};

window.th_close_button_clicked = (details) => {
  if (window.location.pathname === '/pages/widget-page') {
    window.location.href = '/pages/rolling-hard-kustomize-me';
  }
  if (window.location.pathname === '/pages/product-popup') {
    window.location.href = '/pages/account?page=art-locker';
  }
  var hidden_link = document.querySelectorAll('.wc_remove_css_file');
  hidden_link.forEach(function(self){
    var current_href = self.getAttribute('data-href');
    self.setAttribute('href', current_href);
  });
  setTimeout(function(){
    document.querySelector('.customise-popup').style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.tzilla_widget_script').remove();
    document.body.classList.remove('show-product--customizer');
    document.querySelector('html').style.removeProperty('font-size');
  }, 1000);
}
window.wc_viewcart_clicked = () => {
  window.location.href = '/cart';
}
window.th_login_redirect = () => {
  window.location.href = '/account/login';
}

async function extraProductAdd(productVariantID, mainItemKey) {
  try {
    if (!productVariantID) throw new Error('Missing variant ID');
    if (!mainItemKey) throw new Error('Missing main item key');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(productVariantID),
        quantity: 1,
        properties: { '_linked_item_key': mainItemKey, 'IsCustomNeckLable': true }
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Add-to-cart failed: ${text}`);
    }

    const data = await response.json();
    if (data) {
      console.log('Extra product added to cart:', data);
      window.location.href = '/cart';
      document.querySelector('.customise-popup').style.display = 'none';
      document.body.classList.remove('overflow-hidden');
      document.querySelector('.tzilla_widget_script').remove();
      document.body.classList.remove('show-product--customizer');
      document.querySelector('html').style.removeProperty('font-size');
    }
    return data;
  } catch (err) {
    console.error('Error in extraProductAdd():', err);
  }
}
